import { useQuery } from '@tanstack/react-query'

import { QueryKeys } from '../../../../constants/queryKeys.constants'
import { getGeneralConfiguration } from '../../services/configuration.service'
import { ConfigurationCategory } from '../../types/configuration.types'
import { PlanLevel } from '../types/types'

export const usePricingPlan = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [QueryKeys.CONFIGURATION, ConfigurationCategory.GENERAL, 'pricingPlan'],
    queryFn: async () => {
      const configuration = await getGeneralConfiguration()
      return configuration?.pricingPlan ?? PlanLevel.Starter
    },
    enabled: options?.enabled ?? false,
    staleTime: 5 * 60 * 1000,
  })
}
